import React from "react";

interface Option {
  label: string;
  value: string;
}

interface AppRadioProps {
  name: string;
  options: Option[];
  selectedValue: string;
  onChange: (value: string) => void;
  className?: string;
}

const AppRadio: React.FC<AppRadioProps> = ({
  name,
  options,
  selectedValue,
  onChange,
  className,
}) => {
  return (
    <div className={className}>
      {options.map((option) => (
        <label key={option.value} className="app-radio-option">
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={() => onChange(option.value)}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};

export default AppRadio;
